import React from 'react';
import BaseModal from 'flow/components/ui-components/BaseModal';
import { colors } from 'flow/components/ui-components/Button';
import useAppContext from 'flow/hooks/useAppContext';

interface Props {
    title?: string;
    description?: React.ReactNode;
    handleAccept?: () => void;
    confirmButtonText?: string;
    confirmButtonColor?: keyof typeof colors;
    hideCancelButton?: boolean;
}

const ConfirmationDialog = ({
    title,
    description,
    handleAccept,
    confirmButtonText,
    confirmButtonColor,
    hideCancelButton,
}: Props) => {
    const { i18next } = useAppContext();

    return (
        <BaseModal
            open={true}
            header={title}
            onSubmit={handleAccept}
            confirmButtonText={confirmButtonText || i18next.t('ok')}
            confirmButtonColor={confirmButtonColor}
            hideCancelButton={hideCancelButton}
        >
            {description}
        </BaseModal>
    );
};

export default ConfirmationDialog;
